import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-validation-message',
    template: `
        <div *ngIf="control.errors && (control.dirty || control.touched)" class="invalid-feedback" aria-live="polite">
            <div *ngIf="control.errors['required']">*{{ 'validation.required' | translate }}</div>
            <div *ngIf="control.errors['email']">{{ 'validation.email' | translate }}</div>
            <div *ngIf="control.errors['passwordStrength']">{{ control.errors['passwordStrength'] | translate }}</div>
            <div *ngIf="control.errors['mismatch']">{{ 'validation.mismatch' | translate }}</div>
        </div>
    `,
    styles: [
        `
            .invalid-feedback {
                color: red;
                margin-top: 0.5rem;
            }
        `
    ],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class ValidationMessageComponent {
    @Input() control!: AbstractControl;
}
